/**
 * Created by DSadler on 02/05/2017.
 */
import * as _ from "lodash";
let cleanse = (item) => item === undefined ? undefined : JSON.parse(JSON.stringify(item));

export const getTemplateItems = (state, predicate) => {
  return cleanse(_.filter(state.templates, predicate));
};


// WEBPACK FOOTER //
// ./src/App/state/templates/selectors.js